import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { CityActiveUsersCard } from "./CityActiveUsersCard";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const CityActiveUsersPage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;

  return (
    <PageContainer title="Active Users by City">
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
          <Typography variant="h6">Active users by City</Typography>
          <DateRangeNav dateRange={dateRange} />
        </Box>
        <CityActiveUsersCard startDate={startDate} endDate={endDate} />
      </Paper>
    </PageContainer>
  );
};

export default CityActiveUsersPage;
